/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Total_Job_ApplicationsInputs */

const en_total_job_applications = /** @type {(inputs: Total_Job_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Job Applications`)
};

const de_total_job_applications = /** @type {(inputs: Total_Job_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen insgesamt`)
};

/**
* | output |
* | --- |
* | "Total Job Applications" |
*
* @param {Total_Job_ApplicationsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const total_job_applications = /** @type {((inputs?: Total_Job_ApplicationsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Total_Job_ApplicationsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_total_job_applications(inputs)
	return en_total_job_applications(inputs)
});